export default __webpack_public_path__ + "static/media/test.f7f66837.png";